import { learningClient } from '../api'
import { lessonsClient } from '@sphere/school/data-access'
import type {
  GenerateActivityWithAIDto,
  GenerateActivityResponseDto,
  ActivityTypeConfig,
  PreviewActivityWithAIDto,
  PreviewActivityWithAIResponseDto,
  ApproveActivityFromAIDto,
  Activity,
} from '@sphere/learning/domain'
import type { ResourceLightDto } from '@sphere/school/domain'

/**
 * Récupère la liste des ressources d'une leçon
 * @param lessonId
 * @returns ResourceLightDto[]
 */
export async function fetchResources(
  lessonId: string
): Promise<ResourceLightDto[]> {
  const allResources = await lessonsClient.getResources(lessonId)
  // Filtrer les ressources liées à cette leçon via ResourceLink
  return allResources
}

/**
 * Récupère la configuration d'un type d'activité spécifique
 * (jsonSchema et defaultConfig)
 */
export async function fetchActivityTypeConfig(
  typeId: string
): Promise<ActivityTypeConfig> {
  const response = await learningClient.activityTypes.getConfig(typeId)
  return response.data
}

export async function generateActivity(
  request: GenerateActivityWithAIDto
): Promise<GenerateActivityResponseDto> {
  const response = await learningClient.activities.generateWithAI(request)
  return response.data
}

export async function previewGenerateActivity(
  request: PreviewActivityWithAIDto
): Promise<PreviewActivityWithAIResponseDto> {
  const response = await learningClient.activities.previewWithAI(request)
  return response.data
}

export async function approveActivityFromAI(
  request: ApproveActivityFromAIDto
): Promise<Activity> {
  const response = await learningClient.activities.approveFromAI(request)
  return response.data
}

export const activityGenerationService = {
  fetchActivityTypeConfig,
  generateActivity,
  previewGenerateActivity,
  approveActivityFromAI,
}
